import { render } from "./ContextualImage.vue?vue&type=template&id=574e3e10&scoped=true"
import script from "./ContextualImage.vue?vue&type=script&lang=js"
export * from "./ContextualImage.vue?vue&type=script&lang=js"

import "./ContextualImage.vue?vue&type=style&index=0&id=574e3e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574e3e10"]])

export default __exports__